var map = {
	"./Affiliate-white.svg": 568,
	"./about-us.png": 451,
	"./about-us.svg": 569,
	"./affiliate.png": 452,
	"./affiliate.webp": 570,
	"./arrow-down.png": 453,
	"./bet_pnl.png": 454,
	"./blogs.png": 455,
	"./change_no.png": 456,
	"./faqs.png": 457,
	"./faqs.svg": 571,
	"./favorites.png": 458,
	"./feedback.png": 286,
	"./help.svg": 572,
	"./loyalty.png": 459,
	"./loyalty.svg": 573,
	"./market.png": 460,
	"./market.svg": 574,
	"./news.png": 461,
	"./news.svg": 575,
	"./notification.png": 462,
	"./online-betting-app.svg": 576,
	"./open_bets.png": 463,
	"./privacy.png": 464,
	"./privacy.svg": 577,
	"./profile.png": 465,
	"./promotions.png": 466,
	"./promotions.svg": 578,
	"./reset_password.png": 467,
	"./rules.png": 468,
	"./settings.png": 469,
	"./terms-and-conditions.png": 470,
	"./terms-and-conditions.svg": 579,
	"./transactions.png": 471,
	"./wallet.png": 472
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 321;